



























import Vue from "vue";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";
import {isPropertyInFlanders} from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInputRadioGroup: iwInputRadioGroup,
        iwTooltip: iwTooltip
    },
    data: function () {
        return {
            pathInStore: "property.certificates.isAsBuiltPlan",
            radios: [
                {"value": true, "label": "yes"},
                {"value": false, "label": "no"},
                {"value": "not_specified", "label": "not_specified"}
            ],
            inputName: "as_built_plan",
            specificId: uuidv4() as string
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            let country: string = this.$store.getters["FormModule/getValue"]("property.location.address.country");
            let postalCode: string = this.$store.getters["FormModule/getValue"]("property.location.address.postalCode");

            if (country && postalCode && this.$store.getters["FormModule/getValue"]("property.type") !== "LAND") {
                return isPropertyInFlanders(country, postalCode);
            }
            return false;
        },
        isAsBuiltPlan: function(): string|boolean {
            const value = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if (value === true) {
                return true;
            }
            if (value === false) {
                return false;
            }
            return "not_specified";
        },
    },
    methods: {
        updateValue: function(selectedValue: string|boolean): void {
            if (selectedValue == "not_specified") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
            if (selectedValue === true) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": true});
            }
            if (selectedValue === false) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": false});
            }
        }
    }
});

